import elementIsNotNULL from './elementIsNotNULL';

const unobserve = function (element, event, handler) {
    if (elementIsNotNULL(element)) {
        if (element.removeEventListener) {
            element.removeEventListener(event, handler, false);
        } else if (element.detachEvent) {
            element.detachEvent(`un${event}`, handler);
        } else {
            element[`un${event}`] = handler;
        }
    }
};
export default unobserve;
